import { createContext, useState } from "react";
import { Outlet } from "react-router-dom";

const PDDAuthContext = createContext({
  clientAuthInfo: {
    isLoggedIn: false,
    isLoading: true,
    firstName: null,
    lastName: null,
    cellphone: null,
    nationalCode: null,
  },
  setClientAuthInfo: () => {},
});
export default PDDAuthContext;

export const PDDAuthContextProvider = () => {
  const [clientAuthInfo, setClientAuthInfo] = useState({
    isLoggedIn: false,
    isLoading: true,
    firstName: null,
    lastName: null,
    cellphone: null,
    nationalCode: null,
  });

  const context = { clientAuthInfo, setClientAuthInfo };
  return (
    <PDDAuthContext.Provider value={context}>
      <Outlet />
    </PDDAuthContext.Provider>
  );
};
